module.exports = __webpack_public_path__ + "img/VL_08_02.97a25c78.png";